(function() {
    document.addEventListener('DOMContentLoaded', function() {

        var commentsContainer = document.querySelector('.comments');
        var comments          = document.querySelectorAll('.comment-meta');
        var hasEditor         = ( typeof tinymce !== 'undefined' );
        var commentTextarea   = (!hasEditor) ? document.querySelector('.comment-form-comment #comment') : null;
        var currentURL        = window.location.href.split('#')[0];
        var replyButtonClass  = 'comment-reply-button';

        // Handle an edge case: logged-in users who have chosen to "disable the
        // visual editor" get a slightly different comment form class name!
        if (null === commentTextarea) {
            commentTextarea = document.querySelector('.comment-form #comment');
        }

        /**
         * Creates a DOM element for the Reply button
         * @return object The DOM element with Reply text and class attribute
         */
        function replyButton() {
            var replyButton = document.createElement('button');
            replyButton.appendChild(document.createTextNode('Reply'));
            replyButton.classList.add(replyButtonClass);

            return replyButton;
        }

        /**
         * Handles the click event when the REPLY button is pressed
         * @param  object event The click event passed through the event listener
         */
        function handleReply(event) {

            // We're only interested in clicks on Reply buttons
            if ( event.target.className == replyButtonClass ) {

                // Gather information to build our <a> link...
                var comment   = event.target.parentElement.parentElement;
                var author    = comment.querySelector('.comment-author').textContent;
                var replyLink = '<a href="' + currentURL + '#' + comment.id + '">@' + author + '</a>: ';

                if (hasEditor) {

                    // If the TinyMCE editor is present, use its API to add link
                    tinymce.activeEditor.execCommand('mceInsertContent', false, replyLink);
                    document.getElementById('respond').scrollIntoView({behavior: 'smooth', block: 'start'});

                } else {

                    // Otherwise, just handle the basic <textarea> addition
                    commentTextarea.value += replyLink;
                    commentTextarea.focus();

                }

            }

            // Don't allow the event to bubble up to elements where we
            // don't care to listen
            event.stopPropagation();

        }

        if ( comments.length > 0 ) {

            // Add a delegated click handler to the comments' parent
            commentsContainer.addEventListener('click', handleReply);

            /* Add the REPLY button to each comment */
            for (var i=0; i < comments.length; i++) {
                comments[i].appendChild(replyButton());
            }

        }
    });
})();